import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table'
import Cookies from 'js-cookie'
import { BASE_URL } from './commonComponents/ApiEndpoints'
import { Card } from 'react-bootstrap'
import { LuGraduationCap } from 'react-icons/lu'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'

const ParentStudentList = () => {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo } = useInstitute()

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])
  const navigate = useNavigate()

  // Dummy student data
  const [students, setStudents] = useState([])

  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const userCookie = Cookies.get('user')
        if (!userCookie) {
          navigate('/Login')
          return
        }

        const parsedUser = JSON.parse(userCookie)
        const token = parsedUser?.token
        console.log('TOKEN:', token)
        const response = await axios.get(BASE_URL + '/parents/students', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        console.log(response)
        setStudents(response.data.data)
      } catch (error) {
        console.log(error.response?.data?.message)
      }
    }
    fetchData()
  }, [])

  const handleView = (id) => {
    if (!id) {
      console.error('Student ID is undefined')
      return
    }
    console.log('Navigate to : ', `/parent/student/profile/${id}`)
    navigate(`/parent/student/profile/${id}`)
  }


  return (
<>  
      <style>
        {`
          .table td {
            user-select: text;
          }
          .table tbody tr {
            cursor: default;
          }
        `}
      </style>

<div
style={{
  marginLeft,
  transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
  willChange: 'margin-left',
  WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
  position: 'relative',
  zIndex: 1,
  marginTop: '0px',
  marginRight: '0px',
  marginBottom: '0px',
  paddingLeft: isCollapsed ? '62px' : '12px',
  paddingRight: isCollapsed ? '62px' : '12px',
}}
>
      {/* Header (aligned with rest of app) */}
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 992 ? '55px' : '-12px',
          paddingLeft: '0px',
          paddingRight: '0px',
        }}
      >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
              // width: '100%',
            }}
          >
            <div className="d-flex align-items-center gap-3" style={{ flex: 1 }}>
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  background: '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                {!logoError ? (
                  <img
                    src={logo}
                    alt="School Logo"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>

              <div>
                <h3
                  className="m-0 fw-bold text-start"
                  style={{
                    letterSpacing: '-0.02em',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontSize: 'clamp(18px, 2.5vw, 22px)',
                    color: '#223843',
                    lineHeight: '1.2',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  Students
                </h3>
                <p
                  className="m-0 mt-1 text-start"
                  style={{
                    fontSize: window.innerWidth < 768 ? '11px' : '13px',
                    color: '#6b7280',
                    fontWeight: '400',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  View your linked students.
                </p>
              </div>
            </div>

            {!isMobile && <ProfileDropdown logout={logout} />}
          </div>
        </div>
      </div>

      <div
        className="container-fluid p-0 mt-4"
        style={{
          minHeight: '100vh',
          paddingLeft: isCollapsed ? '32px' : '40px',
          paddingRight: '32px',
          paddingTop: '32px',
          paddingBottom: '32px',
        }}
      >
        <Card
          style={{
            border: '1px solid #D1D3D4',
            borderRadius: '12px',
            overflow: 'hidden',
            backgroundColor: '#ffffff',
          }}
        >
          <Table
            className="table mb-0"
            style={{ borderRadius: '12px', overflow: 'hidden' }}
          >
            <Thead>
              <Tr style={{ backgroundColor: '#F3F4F6' }}>
                <Th
                  style={{
                    fontSize: '13px',
                    fontWeight: '600',
                    padding: '16px',
                    border: 'none',
                    borderBottom: '1px solid #D1D3D4',
                    textAlign: 'left',
                    color: '#111827',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  #
                </Th>
                <Th
                  style={{
                    fontSize: '13px',
                    fontWeight: '600',
                    padding: '16px',
                    border: 'none',
                    borderBottom: '1px solid #D1D3D4',
                    textAlign: 'left',
                    color: '#111827',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  Name
                </Th>
                <Th
                  style={{
                    fontSize: '13px',
                    fontWeight: '600',
                    padding: '16px',
                    border: 'none',
                    borderBottom: '1px solid #D1D3D4',
                    textAlign: 'left',
                    color: '#111827',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  Email
                </Th>
                <Th
                  style={{
                    fontSize: '13px',
                    fontWeight: '600',
                    padding: '16px',
                    border: 'none',
                    borderBottom: '1px solid #D1D3D4',
                    textAlign: 'center',
                    color: '#111827',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  Actions
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {students.length > 0 ? (
                students.map((student, index) => (
                  <Tr
                    key={student.id}
                    style={{
                      backgroundColor:
                        index % 2 === 0
                          ? '#ffffff'
                          : 'rgba(243, 244, 246, 0.4)',
                    }}
                  >
                    <Td
                      style={{
                        fontSize: '14px',
                        padding: '16px',
                        border: 'none',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        textAlign: 'left',
                      }}
                    >
                      {index + 1}
                    </Td>
                    <Td
                      style={{
                        fontSize: '14px',
                        padding: '16px',
                        border: 'none',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        textAlign: 'left',
                        fontWeight: '600',
                      }}
                    >
                      {student.name}
                    </Td>
                    <Td
                      style={{
                        fontSize: '14px',
                        padding: '16px',
                        border: 'none',
                        color: '#374151',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        textAlign: 'left',
                      }}
                    >
                      {student.email}
                    </Td>
                    <Td
                      style={{
                        padding: '16px',
                        border: 'none',
                        textAlign: 'center',
                      }}
                    >
                      <button
                        className="btn btn-sm"
                        onClick={() => handleView(student.id)}
                        style={{
                          backgroundColor: '#223843',
                          color: '#ffffff',
                          borderRadius: '10px',
                          border: 'none',
                          padding: '8px 14px',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          fontWeight: 600,
                        }}
                      >
                        View
                      </button>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td
                    colSpan="4"
                    className="text-center"
                    style={{
                      padding: '40px',
                      fontSize: '14px',
                      color: '#6b7280',
                      fontFamily: 'Inter, system-ui, sans-serif',
                      border: 'none',
                    }}
                  >
                    No students available
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </Card>
      </div>
    </div>
    </>
  )
};

export default ParentStudentList
